import React, { Component } from 'react'
import SectionsPV from './SectionsPV'
import AuthA from '../../store/actions/AuthA'
import Papa from 'papaparse'

import axios from 'axios'
import sortBy from 'lodash/sortBy'
import find from 'lodash/find'
import {connect} from 'react-redux'

const _ = {
    sortBy: sortBy,
    find: find
}

class SectionPC extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      searchKey: '',
      fields: ['gradeLevel', 'name', 'levelType', 'teacher', 'actions'],
      activePage: 1,
      itemPerPage: 10,
      selectedIndex: 0,
      column: null,
      direction: null,
      loaded: false,
      teachers: [],
      schoolYears: [],
      sectionStudents: [],
      students: [],
      sectionSubjects: [],
      subjects: [],
      currentSchoolYear: '',
      schoolYearId: '',
      results: []
    };
    this.onSearchChange = this.onSearchChange.bind(this);
    this.getSection = this.getSection.bind(this);
    this.getTeachers = this.getTeachers.bind(this);
    this.getSectionStudents = this.getSectionStudents.bind(this);
    this.getStudents = this.getStudents.bind(this);
    this.getSectionSubjects = this.getSectionSubjects.bind(this);
    this.getSubjects = this.getSubjects.bind(this);
    this.handlePaginationChange = this.handlePaginationChange.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.handleRowClick = this.handleRowClick.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleSubmitSectionStudent = this.handleSubmitSectionStudent.bind(this);
    this.handleDeleteSectionStudent = this.handleDeleteSectionStudent.bind(this);
    this.handleSubmitSectionSubject = this.handleSubmitSectionSubject.bind(this);
    this.handleDeleteSectionSubject = this.handleDeleteSectionSubject.bind(this);
    this.handleUpdateSectionSubject = this.handleUpdateSectionSubject.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleDataChange = this.handleDataChange.bind(this);
    this.handleDataSaveStudents = this.handleDataSaveStudents.bind(this);
    this.handleDataSaveSubjects = this.handleDataSaveSubjects.bind(this);
  }

  getSection() {
    axios.get(process.env.REACT_APP_URL+'/sections?filter[where][active]=true&filter[include]=teacher&filter[where][schoolYearId]='+this.state.schoolYearId)
    .then(response => {
      this.setState({ data: response.data, loaded: true });
    });
  }

  getTeachers() {
    axios.get(process.env.REACT_APP_URL+'/teachers?filter[where][active]=true', {
      params: {
        access_token: localStorage.getItem('token')
      }
    })
    .then(response => {
      this.setState({ teachers: response.data });
    });
  }

  getSchoolYears() {
    axios.get(process.env.REACT_APP_URL+'/schoolyears?filter[where][active]=true')
    .then(response => {
      const currentSchoolYear = _.find(response.data, {
        isCurrent: true
      });
      this.setState({
        schoolYears: response.data,
        schoolYearId: currentSchoolYear.schoolYearId,
        currentSchoolYear: currentSchoolYear
      }, function(){
        this.getSection();
        this.getTeachers();
        this.getSubjects();
        this.getStudents();
      });
    });
  }

  getSectionStudents(sectionId) {
    axios.get(process.env.REACT_APP_URL+'/sectionStudents?filter[where][active]=true&filter[include]=student&filter[where][sectionId]='+sectionId)
    .then(response => {
      const sorted = _.sortBy(response.data, function(o){return [o.student.lastName, o.student.firstName]})
      this.setState({ sectionStudents: sorted });
    });
  }

  getStudents() {
    if (!this.state.schoolYearId) {
      return;
    }
    
    axios.get(`${process.env.REACT_APP_URL}/students?filter[where][active]=true&filter[where][schoolYears]=${this.state.schoolYearId}`)
    .then(response => {
      this.setState({ students: response.data });
    })
    .catch(error => {
      console.error('Error loading students:', error);
    });
  }

  getSectionSubjects(sectionId) {
    axios.get(process.env.REACT_APP_URL+'/sectionSubjects?filter[where][active]=true&filter[include]=subject&filter[include]=teacher&filter[include]=details&filter[where][sectionId]='+sectionId)
    .then(response => {
      this.setState({ sectionSubjects: response.data });
    });
  }

  getSubjects() {
    axios.get(process.env.REACT_APP_URL+'/subjects?filter[where][active]=true&filter[where][schoolYearId]='+this.state.schoolYearId)
    .then(response => {
      this.setState({ subjects: response.data });
    });
  }

  isSearched(searchKey) {
    return function(item) {
      return (
        !searchKey ||
        item.name.toLowerCase().includes(searchKey.toLowerCase()) ||
        item.gradeLevel.toLowerCase().includes(searchKey.toLowerCase())
      );
    };
  }

  onSearchChange(event) {
    this.setState({ searchKey: event.target.value });
  }

  handleSort(clickedColumn) {
    const { column, data, direction } = this.state
    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        data: _.sortBy(data, [clickedColumn]),
        direction: 'ascending',
      })
      return
    }
    this.setState({
      data: data.reverse(),
      direction: direction === 'ascending' ? 'descending' : 'ascending',
    })
  }

  handlePaginationChange(e, {activePage}){
    this.setState({
      activePage: activePage,
    });
  }

  handleRowClick(section) {
    this.props.history.push(this.props.location.pathname+'/' + section.sectionId);
  }

  handleSubmit(data) {
    const url = process.env.REACT_APP_URL+'/sections';
    axios
      .request({
        method: 'post',
        url: url,
        data: data
      })
      .then(response => {this.getSection()})
      .catch(err => console.log(err));
  }

  handleUpdate(data,id) {
    const url = process.env.REACT_APP_URL+'/sections/'+id;
    axios
      .request({
        method: 'put',
        url: url,
        data: data
      })
      .then(response => {this.getSection()})
      .catch(err => console.log(err));
  }

  handleDelete(id) {
    const url = process.env.REACT_APP_URL+'/sections/'+id;
    axios
      .request({
        method: 'put',
        url: url,
        data: {active: false}
      })
      .then(response => {this.getSection()})
      .catch(err => console.log(err));
  }

  handleChange = (e, { value }) => {
    this.setState({ schoolYearId: value }, () => {
      this.getSection()
      this.getStudents()
    })
  }

  handleSubmitSectionStudent(studentId, sectionId) {
    const url = process.env.REACT_APP_URL+'/sectionStudents';
    const data = {
      studentId: studentId,
      sectionId: sectionId
    };
    axios
      .request({
        method: 'post',
        url: url,
        data: data
      })
      .then(response => {this.getSectionStudents(sectionId)})
      .catch(err => console.log(err));
  }

  handleSubmitSectionSubject(subjectId, sectionId, teacherId) {
    const url = process.env.REACT_APP_URL+'/sectionSubjects';
    const data = {
      subjectId: subjectId,
      sectionId: sectionId,
      teacherId: teacherId,
      schoolYearId: this.state.schoolYearId
    };
    axios
      .request({
        method: 'post',
        url: url,
        data: data
      })
      .then(response => {this.getSectionSubjects(sectionId)})
      .catch(err => console.log(err));
  }


  handleUpdateSectionSubject(sectionId, teacherId, id, sem) {
    console.log(teacherId)
    const url = process.env.REACT_APP_URL+'/sectionSubjects/'+id;
    const data = {
      teacherId: teacherId,
      sem: sem
    };
    axios
      .request({
        method: 'put',
        url: url,
        data: data
      })
      .then(response => {this.getSectionSubjects(sectionId)})
      .catch(err => console.log(err));
  }

  handleDeleteSectionStudent(id, sectionId) {
    const url = process.env.REACT_APP_URL+'/sectionStudents/'+id;
    axios
      .request({
        method: 'put',
        url: url,
        data: {active: false}
      })
      .then(response => {this.getSectionStudents(sectionId)})
      .catch(err => console.log(err));
  }

  handleDeleteSectionSubject(id, sectionId) {
    const url = process.env.REACT_APP_URL+'/sectionSubjects/'+id;
    axios
      .request({
        method: 'put',
        url: url,
        data: {active: false}
      })
      .then(response => {this.getSectionSubjects(sectionId)})
      .catch(err => console.log(err));
  }

  handleFileChange(file, sectionId) {
    const self = this;
    Papa.parse(file, {
      header: true,
      dynamicTyping: true,
      skipEmptyLines: true,
      complete: function(results) {
        self.handleDataChange(results, sectionId)
    	}
    });
  }

  handleDataChange(results, sectionId) {
    // this.handleDataSave(results.data, sectionId);
    this.setState({results: results.data})
    console.log('Parsing complete:', results);
  }

  handleDataSaveStudents(sectionId) {
    const data = this.state.results;
    let parsedStudent = {};

    for (let i = 0; i < data.length; i++) {

      // const firstName = data[i]['First Name'];
      // const lastName = data[i]['Last Name'];
      const studentNumber = data[i]['Student Number'];
      const url = process.env.REACT_APP_URL+'/sectionStudents';

      const student = _.find(this.state.students, {
        studentNumber: studentNumber
      });
      parsedStudent = {
        sectionId: sectionId,
        studentId: student.studentId
      }
      axios
        .request({
          method: 'post',
          url: url,
          data: parsedStudent
        })
        .then(response => {this.getSectionStudents(sectionId)})
        .catch(err => console.log(err));
        // window.location.reload()
    }
  }

  handleDataSaveSubjects(sectionId) {
    const data = this.state.results;
    let parsedSubject = {};

    for (let i = 0; i < data.length; i++) {
      const username = data[i]['Username'];
      const subjectCode = data[i]['Subject Code'];
      const url = process.env.REACT_APP_URL+'/sectionSubjects';

      const teacher = _.find(this.state.teachers, {
        username: username
      });

      const subject = _.find(this.state.subjects, {
        code: subjectCode
      });

      parsedSubject = {
        sectionId: sectionId,
        subjectId: subject.subjectId,
        teacherId: teacher.teacherId,
        schoolYearId: this.state.schoolYearId
      }
      axios
        .request({
          method: 'post',
          url: url,
          data: parsedSubject
        })
        .then(response => {
          console.log(response.data)
        })
        .catch(err => console.log(err));
    }
    this.getSectionSubjects(sectionId)
  }

  componentDidMount() {
    this.props.authFn.getToken()
    this.props.onContentMount({title:'School Setup / Section'});
    this.getSchoolYears();
  }

  render() {
    return (
      <SectionsPV
        auth={this.props.auth}
        userType={this.props.userType}
        activePage={this.state.activePage}
        itemPerPage={this.state.itemPerPage}
        column={this.state.column}
        direction={this.state.direction}
        data={this.state.data}
        teachers={this.state.teachers}
        schoolYears={this.state.schoolYears}
        currentSchoolYear={this.state.currentSchoolYear}
        searchKey={this.state.searchKey}
        fields={this.state.fields}
        loaded={this.state.loaded}
        schoolYearId={this.state.schoolYearId}
        sectionStudents={this.state.sectionStudents}
        students={this.state.students}
        sectionSubjects={this.state.sectionSubjects}
        subjects={this.state.subjects}
        isSearched={this.isSearched}
        onSearchChange={this.onSearchChange}
        getSectionStudents={this.getSectionStudents}
        getSectionSubjects={this.getSectionSubjects}
        handleSort={this.handleSort}
        handlePaginationChange={this.handlePaginationChange}
        handleRowClick={this.handleRowClick}
        handleSubmit={this.handleSubmit}
        handleUpdate={this.handleUpdate}
        handleDelete={this.handleDelete}
        handleChange={this.handleChange}
        handleSubmitSectionStudent={this.handleSubmitSectionStudent}
        handleDeleteSectionStudent={this.handleDeleteSectionStudent}
        handleSubmitSectionSubject={this.handleSubmitSectionSubject}
        handleDeleteSectionSubject={this.handleDeleteSectionSubject}
        handleUpdateSectionSubject={this.handleUpdateSectionSubject}
        handleFileChange={this.handleFileChange}
        handleDataSaveStudents={this.handleDataSaveStudents}
        handleDataSaveSubjects={this.handleDataSaveSubjects}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authFn: AuthA(dispatch)
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.AuthR.auth,
    userType: state.AuthR.userType
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SectionPC);
